import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePaymentMethodShortOptions } from "@/hooks/useEnumOptions";

type PaymentMethodElemProps = {
  isDefault: boolean;
  name: string;
  mode: string;
  onClick: () => void;
};

export const PaymentMethodElem = ({ isDefault, name, mode, onClick }: PaymentMethodElemProps) => {
  const { t } = useTranslation("boClients");
  const paymentMethodShortOptions = usePaymentMethodShortOptions();
  return (
    <div className="flex flex-row items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
      <div className="flex flex-1 flex-col">
        <p className="text-xs font-medium text-gray-500">
          {isDefault
            ? t("profilePaymentMethodElem.defaultBillingEntity")
            : t("profilePaymentMethodElem.additionalBillingEntity")}
        </p>
        <p className="text-sm font-medium text-gray-900">{name}</p>
      </div>
      <div className="flex h-fit w-fit flex-row items-center justify-center gap-2 rounded-lg border border-[#BBF7D0] bg-[#F0FDF4] px-2 py-1">
        <Check className="size-4 text-[#15803D]" />
        <p className="h-fit w-fit text-sm font-medium text-[#15803D]">
          {paymentMethodShortOptions.find((el) => el.value === mode)?.label ||
            t("profilePaymentMethodElem.unknownMode")}
        </p>
      </div>
      <div className="flex flex-row items-center gap-2">
        <Button variant="outline" onClick={onClick}>
          {t("profilePaymentMethodElem.edit")}
        </Button>
      </div>
    </div>
  );
};
